import React from "react";
import css from "../../css/find-agent/areas.module.css";
import Link from "next/link";

const LOCATIONS = [
    ["NC/Asheville", "Asheville, NC"],
    ["TX/Austin", "Austin, TX"],
    ["MA/Boston", "Boston, MA"],
    ["SC/Charleston", "Charleston, SC"],
    ["IL/Chicago", "Chicago, IL"],
    ["CO/Denver", "Denver, CO"],
    ["FL/Destin", "Destin, FL"],
    ["FL/Fort_Lauderdale", "Fort Lauderdale, FL"],
    ["TN/Gatlinburg", "Gatlinburg, TN"],
    ["HI/Honolulu", "Honolulu, HI"],
    ["FL/Key_West", "Key West, FL"],
    ["HI/Lahaina", "Lahaina, HI"],
    ["NV/Las_Vegas", "Las Vegas, NV"],
    ["CA/Los_Angeles", "Los Angeles, CA"],
    ["FL/Miami", "Miami, FL"],
    ["FL/Miami_Beach", "Miami Beach, FL"],
    ["CA/Monterey", "Monterey, CA"],
    ["SC/Myrtle_Beach", "Myrtle Beach, SC"],
    ["NY/Manhattan", "Manhattan, NY "],
    ["NY/New_York", "New York City"],
    ["NY/Niagara_Falls", "Niagara Falls, NY"],
    ["NJ/Ocean_City", "Ocean City, NJ"],
    ["FL/Orlando", "Orlando, FL"],
    ["CA/Riverbank", "Riverbank, CA"],
    ["CA/Palm_Springs", "Palm Springs, CA"],
    ["FL/Panama_City_Beach", "Panama City Beach, FL"],
    ["PA/Philadelphia", "Philadelphia, PA"],
    ["TN/Pigeon_Forge", "Pigeon Forge, TN"],
    ["OR/Portland", "Portland, OR"],
    ["TX/San_Antonio", "San Antonio, TX"],
    ["CA/Santa_Monica", "Santa Monica, CA"],
    ["GA/Savannah", "Savannah, GA"],
    ["WA/Seattle", "Seattle, WA"],
    ["FL/Siesta_Key", "Siesta Key, FL"],
    ["VA/Virginia_Beach", "Virginia Beach, VA"],
    ["WA", "Washington DC"],
];

class Areas extends React.PureComponent {
    render() {
        let columns = [[], [], [], []];

        const colSize = Math.ceil(LOCATIONS.length / columns.length);

        for (let i = 0; i < 4; i++) {
            columns[i] = (
                <div className={css.column} key={i}>
                    {LOCATIONS.map((location, index) => {
                        if (index >= i * colSize && index < (i + 1) * colSize) {
                            return (
                                <div className={css.location} key={index}>
                                    <Link
                                        href={`/agents?location=${location[0]}`}
                                        as={`/real_estate_agents/${location[0]}`}
                                    >
                                        {location[1]}
                                    </Link>
                                </div>
                            );
                        }
                    })}
                </div>
            );
        }

        return (
            <div className={css.areas}>
                <div className={css.text}>
                    Whether you’re buying or selling, it just got easier to find
                    local real estate agents. At Residential.com, we have
                    thousands of local realtors who will help you get the lowest
                    prices in residential real estate. Just don’t treat this
                    like Netflix and spend all your time looking for agents only
                    to pass out on the couch.
                </div>

                <div className={css.header}>United States</div>
                <div className={css.columns}>
                    {columns.map((column) => column)}
                </div>

                <h3>
                    Find an agent that’s in the National Association of Realtors
                    and a good listener.
                </h3>
                <div className={css.text}>
                    At Residential.com, we know everyone has a time frame when
                    buying or selling a home. That’s why we help people find
                    real estate agents quickly and easily. Here you can find a
                    real estate broker that’s a member of the National
                    Association of Realtors, which means they have a real estate
                    license and follow a code of ethics. For sale signs, open
                    houses, state law, adding up agent commission rates; your
                    real estate professional will take care of everything! That
                    leaves you time to browse Netflix and actually find
                    something to watch! Unless, hey, you’re dozing off! At least
                    sleep in bed!
                </div>
            </div>
        );
    }
}

export default Areas;
